export default {
	"documentList.title": "Dokumentenübersicht",
	"documentList.empty": "Keine Dokumente verfügbar.",
	"documentList.downloadAll": "Alle Dokumente herunterladen",
	"documentList.files": "Dokumente",
} as const;
